import { commonAxios } from "../utils/AxiosSettings";

export async function fetchRegions() {
    const response = commonAxios.get(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/region/`
    );

    return response;
}

export async function deleteRegion(region) {
    const res = commonAxios({
        url: `${process.env.REACT_APP_BASE_URL_API}/api/accounts/region/?id=${region.id}`,
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        },
    });
    return res;
}

export async function getFactoriesByRegion(region) {
    const response = commonAxios.get(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/region/?id=${region}`
    );
    return response;
}

export async function setFactoryToRegion(regionId, factoryList) {
    const res = await commonAxios.patch(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/region/?id=${regionId}&operation=transfer`,
        { factories: factoryList }
    );

    return res;
}

export async function createRegion(regionName, timezone) {
    const res = await commonAxios.post(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/region/`,
        { Name: regionName, Region_timezone: timezone }
    );

    return res;
}

export async function renameRegion(regionId, regionName) {
    const res = await commonAxios.patch(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/region/?id=${regionId}&operation=name`,
        {
            Name: regionName,
        }
    );
    return res;
}

export const editTimezone = (regionId, timezone) => {
    const res = commonAxios.patch(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/region/?id=${regionId}&operation=timezone`,
        { Region_timezone: timezone }
    );

    return res;
};
